// extracted by mini-css-extract-plugin
export default {"select":"SelectPlace_select__oqQIh"};